const INIT_STATE = {
  questions: {
    q1: {
      C: "Not familiar at all",
      "C++": "Not familiar at all",
      Java: "Not familiar at all",
      Python: "Not familiar at all",
    },
    q2: {
      Array: "0",
      Queue: "0",
      Stack: "0",
      Linkedlist: "0",
      Heap: "0",
      Trees: "0",
      Graphs: "0",
    },
    q3: {
      Greedy: "0",
      Recursion: "0",
      "Searching/Sorting": "0",
      Math: "0",
      "Dynamic Programming": "0",
    },
    q4: {
      cc_rating: "Not started",
    },
    q5: {
      "Basics of Operating Systems": "Not familiar at all",
      "Components of Operating Systems": "Not familiar at all",
      "Process and Threads": "Not familiar at all",
      "Deadlocks in Operating System": "Not familiar at all",
      "Memory Management": "Not familiar at all",
      "Segmentation and Disk Management": "Not familiar at all",
    },
    q6: {
      "Introduction to DBMS & its architecture": "Not familiar at all",
      "Keys and SQL": "Not familiar at all",
      "Practical Problem Solving": "Not familiar at all",
      "Different Types of Normalization": "Not familiar at all",
      "Indexing and transaction management": "Not familiar at all",
    },
    q7: {
      "Introduction to Computer Networks": "Not familiar at all",
      "Types of Layers & Network Topologies": "Not familiar at all",
      "Introduction to Flow and Error Control": "Not familiar at all",
      "Packets and Subnets": "Not familiar at all",
      "Segmentation and Multiplexing": "Not familiar at all",
      "Network Security": "Not familiar at all",
    },
    q8: {
      "Verbal Ability": "0",
      "Quantitative Aptitude": "0",
      "Logical Reasoning": "0",
    },
    q9: {
      project: "0 strong projects",
    },
  },
};

export default INIT_STATE;

// export default {
//   questions: {
//     q1: {
//       C: "Not familiar at all",
//       "C++": "Beginner",
//       Java: "Decent",
//       Python: "Intermediate",
//     },
//     q2: {
//       Array: "0",
//       Queue: "1-20",
//       Stack: "21-50",
//       Linkedlist: "51-100",
//       Heap: "100+",
//       Trees: "51-100",
//       Graphs: "21-50",
//     },
//     q3: {
//       Greedy: "0",
//       Recursion: "1-50",
//       "Searching/Sorting": "51-100",
//       Math: "101-250",
//       "Dynamic Programming": "250+",
//     },
//     q4: { cc_rating: "3 stars" },
//     q5: {
//       "Introduction to Operating Systems": "Not familiar at all",
//       "Components of Operating Systems": "Beginner",
//       "Process and Threads": "Decent",
//       "Process Scheduling Algorithms": "Intermediate",
//       "Process Synchronization": "Very Good",
//       "Overview of Deadlocks": "Intermediate",
//       "Memory Management": "Decent",
//       "Paging and Virtual Memory": "Beginner",
//       "Segmentation and Disk Management": "Not familiar at all",
//     },
//     q6: {
//       "Introduction to DBMS & its architecture": "Not familiar at all",
//       "Keys and SQL": "Beginner",
//       "Practical Problem Solving": "Decent",
//       "Different Types of Normalization": "Intermediate",
//       "Indexing and transaction management": "Very Good",
//     },
//     q7: {
//       "Introduction to Computer Networks": "Not familiar at all",
//       "Physical Layer and Network Topologies": "Beginner",
//       "Hardware Devices and Data Link Layer": "Decent",
//       "Introduction to Flow and Error Control": "Intermediate",
//       "Network Layer and IP Addressing": "Very Good",
//       "Switching and types of routing": "Very Good",
//       "Packets and Subnets": "Intermediate",
//       "Transport layer and its applications": "Decent",
//       "Segmentation and Multiplexing": "Beginner",
//       "Application layer and its protocols": "Not familiar at all",
//       "Network Security": "Beginner",
//     },
//     q8: {
//       "Verbal Ability": "1-20",
//       "Quantitative Aptitude": "21-50",
//       "Logical Reasoning": "51-100",
//     },
//     q9: { project: "1 strong project" },
//   },
// };
